export default __webpack_public_path__ + "static/media/toggleTrendDataInActiveIcon.b42c0ae0.svg";